import TablePage from '@/found/components/table_page';
import { Form } from '@/found/views/mdm/views/terminal_info/form';

export default {
  extends: TablePage,
  components: {
    Form,
  },
  data() {
    return {};
  },
  mounted() {
    this.getConfigList('main_list');
  },
  methods: {
    cellClick({ row, column }) {
      if (column.property === 'terminalCode') {
        this.formName = 'Form';
        this.formConfig = {
          ...row,
          // type: 'fengxianghui',
        };
        this.formConfig.code = 'view';
        this.modalConfig.title = '终端信息';
        this.openFull();
      }
    },
  },
};
